import { render } from "./Footer.vue?vue&type=template&id=0fc2ad4b"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import exportComponent from "/home/ewerson/Projetos/vue/vitrine_digital/vitrine-crescimentoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__